import React from 'react'

const MotorTestsPage = () => {
  return (
    <div>Motor Tests Page</div>
  )
}

export default MotorTestsPage